const sizes = [{
    id: '1',
    size: '4.5/5',
  	type: "Kid's Shoes"
}, {
   id: '2',
   size: '5.5',
   type: "Kid's Shoes"
}, {
   id: '3',
   size: '6/6.5',
   type: "Kid's Shoes"
}, {
   id: '4',
   size: '7/7.5',
   type: "Kid's Shoes"
}, {
   id: '5',
   size: '8',
   type: "Kid's Shoes"
}, {
   id: '6',
   size: '8.5/9',
   type: "Kid's Shoes"
}, {
   id: '7',
   size: '9.5',
   type: "Kid's Shoes"
}, {
   id: '8',
   size: '10/10.5',
   type: "Kid's Shoes"
}, {
   id: '9',
   size: '11',
   type: "Kid's Shoes"
}, {
   id: '10',
   size: '11.5',
   type: "Kid's Shoes"
}, {
   id: '11',
   size: '12/12.5',
   type: "Kid's Shoes"
}, {
   id: '12',
   size: '13/13.5',
   type: "Kid's Shoes"
}, {
   id: '13',
   size: '6',
   type: "Women's Shoes"
}, {
   id: '14',
   size: '7',
   type: "Women's Shoes"
}, {
   id: '15',
   size: '8',
   type: "Women's Shoes"
}, {
   id: '16',
   size: '9',
   type: "Women's Shoes"
}, {
   id: '17',
   size: '10',
   type: "Women's Shoes"
}, {
   id: '18',
   size: '11',
   type: "Women's Shoes"
}, {
   id: '19',
   size: '12',
   type: "Women's Shoes"
}, {
   id: '20',
   size: '8',
   type: "Men's Shoes"
}, {
   id: '21',
   size: '9',
   type: "Men's Shoes"
}, {
   id: '22',
   size: '10',
   type: "Men's Shoes"
}, {
   id: '23',
   size: '11',
   type: "Men's Shoes"
}, {
   id: '24',
   size: '12',
   type: "Men's Shoes"
}, {
   id: '25',
   size: '13',
   type: "Men's Shoes"
}, {
   id: '26',
   size: '3-6M',
   type: "Baby's Shoes"
}, {
   id: '27',
   size: '6-9M',
   type: "Baby's Shoes"
}, {
   id: '28',
   size: '9-12M',
   type: "Baby's Shoes"
}, {
   id: '29',
   size: '1',
   type: "US-Youth Sizes"
}, {
   id: '30',
   size: '1.5/2',
   type: "US-Youth Sizes"
}, {
   id: '31',
   size: '2.5/3',
   type: "US-Youth Sizes"
}, {
   id: '32',
   size: '3.5/4',
   type: "US-Youth Sizes"
}];